import React from 'react'
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom'
import { hot } from 'react-hot-loader'

import Navigation from '~/components/Navigation'
import PrivateRoute from '~/HOC/PrivateRoute'
import * as pages from '~/pages'
import * as routes from '~/pages/routes'

import { auth, getOrdersRef } from '~/firebase'
import { getBasketItems } from '~/utils'

import 'antd/lib/grid/style/index.css'
import '~/fonts/fonts.css'
import '~/App.css'

// const logo = require('~/logo.svg')
// const logoFuture = require('~/logo-future.png')


export let setAppState: typeof App.prototype.setState


class App extends React.Component {
  state = {
    basket: getBasketItems() as string[],
    orders: [] as any[],
  }

  constructor(props) {
    super(props)

    // hacky yes
    setAppState = this.setState.bind(this)
  }

  ordersRef

  componentDidMount() {
    auth.onAuthStateChanged(user => {
      this.forceUpdate()
      if (user) {
        this.ordersRef = getOrdersRef()
        this.ordersRef.on('value', this.setOrders)
      }
    })
  }

  componentWillUnmount() {
    if (this.ordersRef) this.ordersRef.off()
  }

  setOrders = (snapshot: firebase.database.DataSnapshot) => {
    const orders = [] as any[]

    snapshot.forEach(item => {
      orders.push({...item.val(), key: item.key})
      return false
    })

    this.setState({orders})
  }


  render() {
    return (
      <Router>
      <>
        <Navigation basket={this.state.basket} orders={this.state.orders}/>
        <Isomorphic>
          <Switch>

            {/* PRIVATE ROUTES */}

            <PrivateRoute
              exact path={routes.DASHBOARD}
              component={pages.Dashboard}
            />
            <PrivateRoute
              exact path={routes.DASHBOARD_SOLO}
              component={pages.DashboardSolo}
            />
            <PrivateRoute
              exact path={routes.DASHBOARD_MULTI}
              component={pages.DashboardMulti}
            />

            <PrivateRoute
              exact path={routes.ACCOUNT}
              component={pages.Account}
            />

            <PrivateRoute
              path={routes.BASKET.INDEX}
              render={() => <pages.Basket basket={this.state.basket}/>}
            />
            <PrivateRoute
              path={routes.ORDERS}
              render={() => <pages.Orders orders={this.state.orders}/>}
            />

            <PrivateRoute
              exact path={routes.ADMIN}
              component={pages.AdminPanel}
            />

            <PrivateRoute
              exact path={routes.DEVTOOLS.API}
              component={pages.API}
            />

            {/* PUBLIC ROUTES */}

            <Route
              exact path={routes.LANDING}
              component={pages.LandingPage}
            />
            <Route
              exact path={routes.SIGN_IN}
              component={pages.SignIn}
            />
            <Route
              exact path={routes.DEVTOOLS.FONTS}
              component={pages.Fonts}
            />

            <Route
              exact path={routes.DEVTOOLS.INDEX}
            />

            {/* DEFAULT ROUTE - must be last in Switch */}

            <Redirect to={routes.LANDING}/>

          </Switch>
        </Isomorphic>
      </>
      </Router>
    )
  }
}

const Isomorphic = ({children}) => (
  <div className="isoContentMainLayout ant-layout" style={{minHeight: '100vh'}}>
    <div className="isomorphicContent ant-layout-content"
      style={{padding: '70px 0px 0px', flexShrink: 0, background: 'rgb(241, 243, 246)', position: 'relative', height: '100%'}}
    >
      {children}
    </div>
    <div className="ant-layout-footer"
      style={{background: 'rgb(255, 255, 255)', textAlign: 'center', borderTop: '1px solid rgb(237, 237, 237)'}}
    >Cloud Mining ©2018 Created by qwerty@qry.me</div>
  </div>
)

export default hot(module)(App)



// WEBPACK FOOTER //
// ./src/App.tsx